import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export enum TipoNotificacaoEnum {
  PUSH = 'push',
  WEBSOCKET = 'websocket',
  BOTH = 'both',
}

export enum DestinatarioTipoEnum {
  TODOS = 'todos',
  RESTAURANTES = 'restaurantes',
  USUARIOS = 'usuarios',
}

export interface NotificacaoRequest {
  titulo: string;
  mensagem: string;
  tipo: TipoNotificacaoEnum;
  destinatarioTipo: DestinatarioTipoEnum;
  destinatarios?: string[];
  dataAgendamento: string;
  dadosAdicionais?: Record<string, unknown>;
}

@Injectable({
  providedIn: 'root',
})
export class NotificacoesAgendadasService {
  constructor(private http: HttpClient) {}

  async criar(body: NotificacaoRequest): Promise<any> {
    return await lastValueFrom(
      this.http.post<any>(
        `${environment.apiUrl}/scheduled-notifications`,
        body,
      ),
    ).catch((err) => {
      throw err.error.error;
    });
  }

  async buscarNotificacoesUsuario(userId: string): Promise<any> {
    return await lastValueFrom(
      this.http.get<any>(
        `${environment.apiUrl}/scheduled-notifications/me/${userId}`,
      ),
    ).catch((err) => {
      throw err.error.error;
    });
  }

  async marcarTodasComoLidas(id: string): Promise<any> {
    return await lastValueFrom(
      this.http.patch<any>(
        `${environment.apiUrl}/scheduled-notifications/mark-all-read/${id}`,
        {},
      ),
    ).catch((err) => {
      throw err.error.error;
    });
  }
}
